<div *ngIf="isUpdating" class="updating-overlay"></div>

<div class="table-container" *ngIf="list">
  <cc-list-headers
    class="list-header"
    [listId]="list._id"
    [listProperties]="list.properties"
    [itemCount]="list.items?.length"
    [selectedItemCount]="(selectedItems | async).size"
    [isDeployedList]="isDeployedList"
    [canEditProperties]="canEditProperties"
    [users]="users"
    [parentId]="parentId"
    [hierarchy]="folder.hierarchy"
    [planType]="folder.planType"
    [isUpgradeModalVisible]="isUpgradeModalVisible"
    [hasReachedPlanLimit]="hasReachedPlanLimit"
    [isInCreatePropertyMode]="isInCreatePropertyMode"
    [beforeAddPropertyIterator]="beforeAddPropertyIterator"
    [afterAddPropertyIterator]="afterAddPropertyIterator"
    [addPropertyIndex]="addPropertyIndex"
    (propertyMoved)="onPropertyMoved($event)"
    (propertyChanged)="onListHeaderPropertyChanged($event)"
    (propertyDeleted)="onListPropertyDeleted($event)"
    (propertyAddedInBetween)="onListPropertyAddedInBetween($event)"
    (startAddProperty)="onStartAddProperty($event)"
    (requestPropertyCreateMode)="requestPropertyCreateMode()"
    (propertyAddCancelled)="cancelAddPropertyInBetween()"
    (propertyCreated)="onListPropertyUpdated($event)"
    (toggleSelectAll)="toggleSelectAllItems()"
  ></cc-list-headers>

  <ng-container *ngFor="let item of list.items; let i = index; trackBy: trackItemById">
    <cc-list-row
      [item]="item"
      [list]="list"
      [parentId]="parentId"
      [isDeployedList]="isDeployedList"
      [canEditProperties]="canEditProperties"
      [isSelected]="isSelected(item._id)"
      [folder]="folder"
      [beforeAddPropertyIterator]="beforeAddPropertyIterator"
      [afterAddPropertyIterator]="afterAddPropertyIterator"
      [addPropertyIndex]="addPropertyIndex"
      [itemPropertyTypes]="listItemPropertyMap"
      (toggleRowSelect)="toggleItemSelection(item._id)"
      (itemPropertyInteracted)="shouldExpandRow(item._id, $event)"
      (toggleRowExpand)="toggleExpandItem(item._id)"
      (itemEdited)="onListItemEdited(item, $event)"
      (setEditMode)="setItemEditMode(item, $event)"
      (itemEditCancelled)="onListItemEditCancelled(item)"
      (itemStyleUpdated)="onListItemStyleUpdated(item, $event)"
      (listCellUpdated)="onListCellUpdated(item, $event)"
      (listDeployed)="onListDeployed($event)"
      class="list-item"
      data-test="list-item-non-static"
      [class.new]="item.editing === true && item.isNew === true"
      [class.expanded]="expandedRow === item._id"
    ></cc-list-row>
  </ng-container>

  <div
    data-test="addItem"
    class="list-item sm-flex-1"
    [class.expand-list-row]="list?.properties?.length > 0"
    *ngIf="!isCreatingNewListItem"
  >
    <div class="frozen-columns">
      <div class="list-item-action-cell"></div>
      <div *ngIf="list" class="add-list-item-container">
        <button [disabled]="!canAddNewItem" class="add-item-button" type="button" (click)="startAddItem()">
          <em class="cc-icon cc-icon-plus" aria-hidden="true"></em>
          <span>Add item</span>
        </button>
      </div>
    </div>
    <div *ngIf="list" class="list-default-style-container">
      <cc-style-color-picker
        [(style)]="listDefaultStyle"
        (styleChange)="onListDefaultStyleUpdated($event)"
        [defaultStyle]="styleVariants.None"
      ></cc-style-color-picker>
    </div>
  </div>

  <cc-empty-list-state
    *ngIf="shouldDisplayEmptyState"
    [hasItemsButNoProperty]="hasItems && !hasProperties"
    (addProperty)="onStartAddProperty()"
    (startAddItem)="startAddItem()"
    (importCSV)="triggerUploadListCSV.emit()"
  ></cc-empty-list-state>
</div>
